module.exports = __webpack_public_path__ + "static/predefined_template_2-62f55bfec3f9a82d473179114b225963.png";